import {inject, Injectable} from '@angular/core';
import {CmsApiService} from "../core/cms-api.service";
import {SortOrderMenu} from "../core/definitions/search-objects";

@Injectable({
  providedIn: 'root'
})
export class SearchViewSortOrderMenuService {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);

  private sortOrderMenus: {[name: string]: SortOrderMenu[]} = null;

  async getSortOrderMenus(name: string): Promise<SortOrderMenu[]> {
    if (!this.sortOrderMenus) {
      this.sortOrderMenus = await this.cms.getSearchViewSortOrderMenus();
    }
    return this.sortOrderMenus? this.sortOrderMenus[name] || [] : [];
  }
}
